<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div>
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div>
          <label class="label-input">Title</label>
          <ckeditor :editor="editor" v-model="fields.titleFaq" :config="editorConfig" />
        </div>
        <div class="mt-4">
          <!-- list item -->
          <div class="wrap-products-form">
            <div class="d-flex justify-space-between align-center mb-2">
              <label class="label-input" style="margin-bottom: 10px">List FAQ</label>
              <v-btn small color="primary" @click="handleAddFAQ">
                <v-icon size="16">mdi-plus</v-icon>
                <span>Add FAQ</span>
              </v-btn>
            </div>
            <div class="group-item">
              <v-checkbox
                class="mb-4"
                v-model="fields['containerFullWidth']"
                label="Items Full Width"
                dense
                hide-details
              />
              <v-expansion-panels accordion>
                <v-expansion-panel v-for="(item, i) in fields['listItem']" :key="i">
                  <v-expansion-panel-header>
                    <div class="d-flex justify-space-between align-center">
                      <div class="line-clamp-1">{{ item.question }}</div>
                      <v-btn icon @click.stop="handleRemoveItem(i)">
                        <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="wrap-faq-form">
                      <v-text-field v-model="item.question" label="Question" />
                      <div>
                        <label>Answer</label>
                        <ckeditor :editor="editor" v-model="item.answer" :config="editorConfig" />
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>
        <div class="mt-6">
          <label class="label-input">Section Settings</label>
          <div class="group-item">
            <div class="mb-6">
              <div class="font-weight-medium">Spacing</div>
              <v-row>
                <v-col cols="6">
                  <v-checkbox v-model="fields.topPadding" label="Top Spacing" dense hide-details />
                </v-col>
                <v-col cols="6">
                  <v-checkbox v-model="fields.bottomPadding" label="Bottom Spacing" dense hide-details />
                </v-col>
              </v-row>
            </div>
            <div class="mb-6">
              <div class="font-weight-medium mb-3">Container Colors</div>
              <v-row>
                <v-col cols="12" md="12">
                  <ColorPicker
                    v-model="fields.colors.backgroundContainer"
                    name="backgroundColor"
                    label="Container Background Color"
                    default-color="#F7F8F9"
                  />
                </v-col>
              </v-row>
            </div>
            <div>
              <div class="font-weight-medium mb-3">FAQ Item Colors</div>
              <v-row>
                <v-col cols="12" md="4">
                  <ColorPicker
                    v-model="fields.colors.backgroundFaqItem"
                    name="backgroundFaqItem"
                    label="Background Color"
                    default-color=""
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <ColorPicker
                    v-model="fields.colors.textFaqItem"
                    name="textFaqItem"
                    label="Text Color"
                    default-color="#000000"
                  />
                </v-col>
                <v-col cols="12" md="4">
                  <ColorPicker
                    v-model="fields.colors.borderFaqItem"
                    name="borderFaqItem"
                    label="Border Color"
                    default-color="#d3d3d3"
                  />
                </v-col>
              </v-row>
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import ColorPicker from './common/color-picker.vue';

export default {
  name: 'question-and-answer-grid-04-section-editor',
  components: {
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        colors: {
          backgroundContainer: '',
          backgroundFaqItem: '',
          textFaqItem: '',
          borderFaqItem: '',
        },
        titleFaq: '',
        topPadding: true,
        bottomPadding: true,
        containerFullWidth: false,
        listItem: [
          // {
          //   background: '',
          //   question: '',
          //   answer: ''
          // }
        ],
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionFaqGrid04(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleRemoveItem(index) {
      this.fields['listItem'].splice(index, 1);
    },
    handleAddFAQ() {
      this.fields['listItem'].push({
        question: 'New Question',
        answer: 'New Answer',
      });
    },
  },
};
</script>

<style lang="css" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 150px !important;
}
</style>
